import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { reservationDelete, reservationEdit } from 'Global/Stores/reservations'
import { reservationEditModalHide } from 'Global/Stores/modals'
import { reservationEventOptionAdd } from 'Global/Stores/options'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    eventOptions: selectors.eventOptions(state),
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    reservation: selectors.reservation(state),
    reservations: selectors.reservations(state),
    rug: selectors.rug(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    addEventOption: option => dispatch(reservationEventOptionAdd(option)),
    close: () => dispatch(reservationEditModalHide()),
    deleteReservation: (reservation, user) => dispatch(reservationDelete(reservation, user)),
    edit: (reservation, user) => dispatch(reservationEdit(reservation, user)),
  })

  Enhancer.displayName = 'EditReservationModalEnhancer'

  Enhancer.propTypes = {
    addEventOption: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    deleteReservation: PropTypes.func.isRequired,
    edit: PropTypes.func.isRequired,
    eventOptions: PropTypes.array.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    reservation: PropTypes.object.isRequired,
    reservations: PropTypes.array.isRequired,
    rug: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
